import { ComponentOptions } from 'vue';
import Store from '@/store';
import { activityService } from '@/services/v2/ActivityService';

export const ActivityMixin: ComponentOptions = {
  computed: {
    lastActiveDate(): Date | undefined {
      return Store.state.lastActiveDate;
    }
  },
  watch: {
    async lastActiveDate(newVal, oldVal) {
      // router.afterEach bumps lastActiveDate on public routes too, where this can only 401
      // and the interceptor would then redirect a signed-out user away to Cognito.
      if (newVal !== oldVal && Store.state.user) {
        await activityService.setUserLastActive();
      }
    }
  }
};